import { render, staticRenderFns } from "./YcIndex.vue?vue&type=template&id=2d3b91e6&scoped=true&"
import script from "./YcIndex.vue?vue&type=script&lang=js&"
export * from "./YcIndex.vue?vue&type=script&lang=js&"
import style0 from "./YcIndex.vue?vue&type=style&index=0&id=2d3b91e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3b91e6",
  null
  
)

export default component.exports